import React from 'react'
import { useState, useEffect } from 'react';
import FormInput from '../../components/forms/formInput';
import FormSelect from '../../components/forms/formSelect';
import FormTextarea from '../../components/forms/formTextarea';
import GreenButton from '../../components/forms/greenButton';
import ApiUrl from '../../configTools/apiUrl';
import ScreenSizes from '../../configTools/screenSizes';

const Editprofile = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [firstname,setFirstname] = useState('');
    const [lastname,setLastname] = useState('');
    const [location,setLocation] = useState({name:'Select', value:'0'});
    const [locationList,setLocationList] = useState([]);
    const [contact, setContact] = useState('')
    const [address, setAddress] = useState('')
    const [cnic, setCnic] = useState('')
    const [discription,setDiscription] = useState('');
    const [email, setEmail] = useState('')
    const width = window.innerWidth;
    useEffect(() => {
        fetch(ApiUrl.API_URL_Location)
        .then(res=>res.json())
        .then(data =>{
            let locationListSend = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                locationListSend.push({
                    name: element.name,
                    value: String(element.id)
                })
            }
            setLocationList(locationListSend);
            setFirstname(User.firstname);
            setLastname(User.lastname);
            setAddress(User.address);
            setCnic(User.cnic);
            setContact(User.contact);
            setDiscription(User.discription);
            setEmail(User.email);
            setLocation(locationListSend.find(x=>x.value === String(User.location)));
        });
    },[])
    const add_admin = ()=>{
        fetch(ApiUrl.API_URL_Profile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
                Id:User.id,
                firstname: firstname,
                lastname: lastname,
                address: address,
                cnic: cnic,
                contact: contact,
                discription: discription,
                email: email,
                location: parseInt(location.value),
                image : User.image
            })
          })
          .then(res2=>res2.json())
          .then(data2 =>{
            if(data2.success){
                let userNew = User;
                userNew.firstname = firstname;
                userNew.lastname = lastname;
                userNew.address = address;
                userNew.cnic = cnic;
                userNew.contact = contact;
                userNew.discription = discription;
                userNew.email = email;
                userNew.location = parseInt(location.value);
                localStorage.setItem("user-info",JSON.stringify(userNew));
                document.location.reload();
            }
            else{
                console.log(data2.responce);
            }
        });
    }
  return (
    <div className='admin_forms_row'>
        {width > ScreenSizes.Mobile &&
            <div className='admin_col_50'></div>
        }
        <div className={width > ScreenSizes.Mobile?'admin_col_50':'admin_col_100'}>
            <div className='admin_forms_container'>
                <div className='admin_forms_multirow'>
                    <div className='admin_col_50'>
                        <FormInput Lable='First Name' Type='text' Placeholder='Enter First name' Value={firstname} setValue={setFirstname}/>
                    </div>
                    <div className='admin_col_50'>
                        <FormInput Lable='Last Name' Type='text' Placeholder='Enter Last name' Value={lastname} setValue={setLastname}/>
                    </div>
                </div>
                <div className='admin_forms_multirow'>
                    <div className='admin_col_50'>
                        <FormInput Lable='Contact' Type='text' Placeholder='Enter Contact' Value={contact} setValue={setContact}/>
                    </div>
                    <div className='admin_col_50'>
                        <FormInput Lable='Email' Type='text' Placeholder='Enter Email' Value={email} setValue={setEmail}/>
                    </div>
                </div>
                <div className='admin_forms_multirow'>
                    <div className='admin_col_50'>
                        <FormInput Lable='Cnic' Type='text' Placeholder='Enter Cnic' Value={cnic} setValue={setCnic}/>
                    </div>
                    <div className='admin_col_50'>
                        <FormInput Lable='Address' Type='text' Placeholder='Enter Address' Value={address} setValue={setAddress}/>
                    </div>
                </div>
                <div className='admin_forms_multirow'>
                    <div className='admin_col_100'>
                        <FormSelect Lable={'Location'} Value={location} setValue={setLocation} Options={locationList}/>
                    </div>
                </div>
                <div className='admin_forms_multirow'>
                    <div className='admin_col_100'>
                        <FormTextarea Lable='Discription' Type='text' Placeholder='Enter discription' Value={discription} setValue={setDiscription}/>
                    </div>
                </div>
                <div className='admin_forms_multirow'>
                    <div className='admin_col_100'>
                        <GreenButton Value={'Update'} Action={add_admin}/>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Editprofile
